import * as React from "react";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";
import { NoteUpdate } from "./NoteUpdate";
import { TaskUpdate } from "./TaskUpdate";
import { EventInterface } from "../../../Entity/Entities/Event/EventInterface";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import Time from "../../../Time/Time";

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from '@material-ui/core/IconButton';

class Event extends Component {
  protected limit: number = 40;

  constructor(public props) {
    super(props);

    this.state = {
      isEditingNote: false,
      isEditingTask: false,
      isDetailsDialogOpen: false,
      displayLess: true,
      displayMore: false,
      isDeleteEntityPopupOpen: false,
      anchorEl: null
    };
  }

  public updateNote = (event: EventInterface, note: string, snoozeDate: Date | null): void => {
    this.props.dispatch({
      type: Constants.GLOBAL_EVENT_UPDATE_START,
      payload: {
        id: event.id,
        content: {
          note: note
        },
        snoozeDate: snoozeDate,
        ...this.props.relations
      },
      onSuccess: () => {
        this.setState({
          isEditingNote: false
        });

        if (typeof this.props.fetchEntityEvents === "function") {
          this.props.fetchEntityEvents();
        }
      }
    });
  }

  public updateTask = (event: EventInterface, task): void => {
    this.props.dispatch({
      type: Constants.GLOBAL_EVENT_UPDATE_START,
      payload: {
        id: event.id,
        content: {
          name: task.instructions
        },
        executionDate: task.executionDate,
        reporterId: task.reporterId,
        reacted: task.reacted,
        ...this.props.relations
      },
      onSuccess: () => {
        this.setState({
          isEditingTask: false
        });

        if (typeof this.props.fetchEntityEvents === "function") {
          this.props.fetchEntityEvents();
        }
      }
    });
  }

  public delete = (): void => {
    this.props.dispatch({
      type: Constants.GLOBAL_EVENT_DELETE_START,
      payload: {
        event: this.props.event
      },
      onSuccess: () => {
        this.setState({
          isEditingNote: false,
          isEditingTask: false,
          isDeleteEntityPopupOpen: false
        });

        if (typeof this.props.fetchEntityEvents === "function") {
          this.props.fetchEntityEvents();
        }
      }
    });
  }

  public renderDetailsDialog = () => {
    return (
      <PromptDialog
       {...this.props}
        title={[3, 16].includes(this.props.event.eventTypeId) ? this.trans("reminder") : this.trans("event-details")}
        content={
          <CardContent className="text task-text">
            {this.props.event && this.props.event.reason}

            {
              this.props.event && this.props.event.eventTypeId !== 23 && (
                <ul className="relation-info">
                  {this.props.event.person && <li>{this.props.event.person.displayName}</li>}
                  {this.props.event.company && <li>{this.props.event.company.displayName}</li>}
                  {this.props.event.property && <li>{this.props.event.property.displayName}</li>}
                  {this.props.event.content && this.props.event.content.fullUnit && (this.props.event.content.fullUnit.unitNumber || this.props.event.content.fullUnit.unitNumber === 0) && <li>{this.trans("title-updated-unit-number")}</li>}
                  {this.props.event.content && this.props.event.content.fullUnit && (this.props.event.content.fullUnit.unitTypeId || this.props.event.content.fullUnit.unitTypeId === 0) && <li>{this.trans("title-updated-unit-type-id")}</li>}
                  {this.props.event.content && this.props.event.content.fullUnit && (this.props.event.content.fullUnit.paidStatusId || this.props.event.content.fullUnit.paidStatusId === 0) && <li>{this.trans("title-updated-paid-status-id")}</li>}
                  {this.props.event.content && this.props.event.content.fullUnit && (this.props.event.content.fullUnit.squareMeters || this.props.event.content.fullUnit.squareMeters === 0) && <li>{this.trans("title-updated-square-meters")}</li>}
                  {this.props.event.content && this.props.event.content.fullUnit && (this.props.event.content.fullUnit.roomNumber || this.props.event.content.fullUnit.roomNumber === 0) && <li>{this.trans("title-updated-room-number")}</li>}
                  {this.props.event.content && this.props.event.content.fullUnit && (this.props.event.content.fullUnit.bedroomNumber || this.props.event.content.fullUnit.bedroomNumber === 0) && <li>{this.trans("title-updated-bedroom-number")}</li>}
                  {this.props.event.content && this.props.event.content.fullUnit && (this.props.event.content.fullUnit.bathroomNumber || this.props.event.content.fullUnit.bathroomNumber === 0) && <li>{this.trans("title-updated-bathroom-number")}</li>}
                  {this.props.event.content && this.props.event.content.fullUnit && this.props.event.content.fullUnit.publicationTitle && <li>{this.trans("title-updated-publication-title")}</li>}
                  {this.props.event.content && this.props.event.content.fullUnit && (this.props.event.content.fullUnit.unitStatusId || this.props.event.content.fullUnit.unitStatusId === 0) && <li>{this.trans("title-updated-unit-status-id")}</li>}
                  {this.props.event.content && this.props.event.content.fullUnit && (this.props.event.content.fullUnit.planningData || this.props.event.content.fullUnit.planningData === 0) && <li>{this.trans("title-updated-planning-data")}</li>}
                  {this.props.event.content && this.props.event.content.fullUnit && (this.props.event.content.fullUnit.note || this.props.event.content.fullUnit.note === 0) && <li>{this.trans("title-updated-note")}</li>}
                  {this.props.event.contract && <li>{this.props.event.contract.displayName}</li>}
                  {this.props.event.charge && <li>{this.props.event.charge.displayName}</li>}
                  {this.props.event.remindDate && this.props.event.eventTypeId === 3 && <li>{`${this.trans("contract-expiration-date")}: ${Time.formatOrNull(this.props.event.remindDate)}`}</li>}
                  {this.props.event.content?.name && <li>{`${this.trans("dialog-new-notification-text")}: ${this.props.event.content?.name}`}</li>}
                </ul>
              )
            }

            {
              this.props.event && this.props.event.eventTypeId === 32 && (
                <ul className="relation-info">
                  {this.trans("email-was-sent-to")}
                  {this.props.event.content.invoice && this.props.event.content.invoice.email && <li>{this.props.event.content.invoice.email.to}</li>}
                  {this.props.event.content.invoice && this.props.event.content.invoice.email &&
                    this.props.event.content.invoice.email.cc && this.props.event.content.invoice.email.cc.map(email => <li>{email}</li>)
                  }
                </ul>
              )
            }

            {
              this.props.event && this.props.event.eventTypeId === 36 && (
                <ul className="relation-info" style={{listStyleType: "none", whiteSpace: "pre-wrap"}}>
                  <li style={{marginBottom: 6}}>{this.trans("from")}: {this.props.event.content.email?.from}</li>
                  <li style={{marginBottom: 6}}>{this.trans("to")}: {this.props.event.content.email?.to}</li>
                  <li style={{marginBottom: 6}}>Cc: {this.props.event.content.email?.cc}</li>
                  <li style={{marginBottom: 6}}>{this.props.event.content.email?.subject}</li>
                  <li style={{marginBottom: 6}}>{this.props.event.content.email?.message}</li>

                  {/* {this.trans("email-was-sent-to")} */}

                  {/* task */}
                  {this.props.event.content.task && this.props.event.content.task.email && <li>{this.props.event.content.task.email.to}</li>}
                  {this.props.event.content.task && this.props.event.content.task.email &&
                    this.props.event.content.task.email.cc && this.props.event.content.task.email.cc.map(email => <li>{email}</li>)
                  }

                  {/* invoice */}
                  {this.props.event.content.invoice && this.props.event.content.invoice.email && <li>{this.props.event.content.invoice.email.to}</li>}
                  {this.props.event.content.invoice && this.props.event.content.invoice.email &&
                    this.props.event.content.invoice.email.cc && this.props.event.content.invoice.email.cc.map(email => <li>{email}</li>)
                  }

                  {this.props.event?.financialStatementId && this.props.event?.content?.invoice?.statementFirstDate &&
                    <div>  
                 	    <li 
                        style={{marginTop: "10px"}}
                       >
                         <span>{`${this.trans("charge-summary-details/ownerstatement")}`}</span>
                         <span className="link-to-entity" onClick={() => this.redirect(`/app/owner-statement/update/${this.props.event?.financialStatementId}/`)}>{` ${Time.useFormat(this.props.event?.content?.invoice?.statementFirstDate, "MMMM YYYY")}`}</span>
                      </li>
                    </div>
                  }  
                </ul>
              )
            }

            {
              this.props.event &&
              this.props.event.charge &&
              this.props.event.payment &&
              this.props.event.eventTypeId === 23 && (
                <ul className="relation-info">
                  {this.props.event.charge &&
                    <li>{`${this.trans("object")}: ${this.props.event.charge.relatedEntity && this.props.event.charge.relatedEntity.displayName}`}</li>
                  }
                  {this.props.event.payment &&
                    <li>{`${this.trans("label-counterparty")}: ${this.props.event.payment && this.props.event.payment.getPayerDisplayName()}`}</li>
                  }
                </ul>
              )
            }

            {((this.props.event.eventTypeId === 15 || this.props.event.eventTypeId === 16) && (
              <div className="event-link-wrapper">
                <span className="link-to-entity" onClick={() => this.redirect(`/app/notification/update/${this.props.event.id}`)} key={`event-link-${this.props.event.id}`}>{this.trans("open-notification-details")}</span>
              </div>
            ))}

            {((this.props.event.eventTypeId === 34) && (
              <div className="event-link-wrapper">
                <span className="link-to-entity" onClick={() => this.redirect(`/app/activity/update/${this.props.event.id}`)} key={`event-link-${this.props.event.id}`}>{this.trans("open-activity-details")}</span>
              </div>
            ))}

            {((this.props.event.eventTypeId === 35 || this.props.event?.eventTypeId === 38) && (
              <div className="event-link-wrapper">
                <span className="link-to-entity" onClick={() => this.redirect(`/app/task/update/${this.props.event.id}`)} key={`event-link-${this.props.event.id}`}>{this.trans("open-task-details")}</span>
              </div>
            ))}
          </CardContent>
        }
        positiveButtonLabel={this.trans("button-close")}
        openLeavePrompt={this.state.isDetailsDialogOpen}
        prioritizeClosing={true}
        onlyPositiveButton={true}
        onSave={() => this.setState({ isDetailsDialogOpen: false })}
        hideCross={true}
      />
    );
  }

  public shouldShowButtons = () => {
    // should show buttons only for timeline events
    if (this.props.event?.isTimelineEvent) {
      if (this.props.event?.eventTypeId === 36) { // email sent
        return false;
      }

      if (
        this.props.event?.eventTypeId === 17 || // note
        this.props.event?.eventTypeId === 35 || // task
        this.props.event?.eventTypeId === 38    // incident
      ) {
        // for notes and tasks only creator see buttons
        if (this.props.app?.session?.user?.id === this.props.event?.creator?.id) {
          return true;
        } else {
          return false;
        }
      }

      return true;
    }

    return false;
  }

  public shouldShowExpander = () => {
    return !!this.props.event &&
           this.props.event.eventTypeId === 17 &&
           this.props.event.reason.length > this.limit;
  }

  protected openMenu = (event: any): void => {
    // this.selectedCompany = company;

    this.setState({
      anchorEl: event.currentTarget
    });
  }

  protected closeMenu = (): void => {
    this.setState({
      anchorEl: null
    });
  }

  public renderButtons = () => {
    return (
      <div
        className="threedot-icon-container"
        onClick={e => {
          e.stopPropagation();
        }}
        style={{
          position: "absolute",
          top: "6px",
          right: "28px",
          width: "0"
        }}
      >
        <IconButton
          onClick={e => this.openMenu(e)}
        >
          <div className="icon icon-ic-more-vert"></div>
        </IconButton>
        <Menu
          id="simple-menu"
          anchorEl={this.state.anchorEl}
          open={Boolean(this.state.anchorEl)}
          onClose={this.closeMenu}
          disableAutoFocusItem={true}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center"
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left"
          }}
          getContentAnchorEl={null}
        >
          <MenuItem
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();

              if (this.props.event.eventTypeId === 17) {
                return this.setState({
                  isEditingNote: true,
                  isEditingTask: false,
                  anchorEl: null
                });
              }

              if (this.props.event.eventTypeId === 35 || this.props.event?.eventTypeId === 38) {
                return this.setState({
                  isEditingNote: false,
                  isEditingTask: true,
                  anchorEl: null
                });
              }

              if (this.props.event.eventTypeId === 15 || this.props.event.eventTypeId === 16) {
                return this.redirect(`/app/notification/update/${this.props.event.id}`);
              }

              if (this.props.event.eventTypeId === 34) {
                return this.redirect(`/app/activity/update/${this.props.event.id}`);
              }

              if (this.props.event.eventTypeId === 35 || this.props.event?.eventTypeId === 38) {
                return this.redirect(`/app/task/update/${this.props.event.id}`);
              }
            }}
          >
            <ListItemIcon><div className="icon icon-ic-edit aligned"></div></ListItemIcon>
            <ListItemText>{this.trans("menuitem-open")}</ListItemText>
          </MenuItem>
          {
            (
              this.props.event.eventTypeId === 17 || this.props.event.eventTypeId === 34 || this.props.event.eventTypeId === 35 || this.props.event?.eventTypeId === 38) && (
                <MenuItem
                  className="delete-action"
                  onClick={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.setState({ isDeleteEntityPopupOpen: true, anchorEl: null });
                  }}
                >
                  <ListItemIcon><div className="icon icon-ic-remove aligned"></div></ListItemIcon>
                  <ListItemText>{this.trans("menuitem-delete")}</ListItemText>
                </MenuItem>
            )
          }
        </Menu>
      </div>
    );
  }

  public renderContent = (): any => {
    return (
      <div>
        {
          this.state.isEditingNote && (
            <NoteUpdate
              {...this.props}
              event={this.props.event}
              onUpdate={this.updateNote}
              onCancel={() => this.setState({isEditingNote: false})}
            />
          )
        }

        {
          this.state.isEditingTask && (
            <TaskUpdate
              {...this.props}
              event={this.props.event}
              onUpdate={this.updateTask}
              onCancel={() => this.setState({isEditingTask: false})}
            />
          )
        }

        {!this.state.isEditingNote && !this.state.isEditingTask && (
          <div className="event-subject">
            {!!this.props.event && !this.shouldShowExpander() && this.props.event.subject}
            {!!this.props.event && this.shouldShowExpander() && this.state.displayLess && this.props.event.subject && this.props.event.subject.substring(0, this.limit)}
            {!!this.props.event && this.shouldShowExpander() && this.state.displayMore && this.props.event.subject}
            {this.shouldShowExpander() && (
              <div>
                {this.state.displayLess && (
                  <div>
                    <Button
                      color="primary"
                      onClick={() => this.setState({displayMore: true, displayLess: false})}
                      style={{width: "100%", height: "20px", padding: "0"}}
                    >
                      <div className="icon icon-ic-keyboard-arrow-down icon-color"></div>
                    </Button>
                  </div>
                )}
                {this.state.displayMore && (
                  <div>
                    <Button
                      color="primary"
                      onClick={() => this.setState({displayMore: false, displayLess: true})}
                      style={{width: "100%", height: "20px", padding: "0"}}
                    >
                      <div className="icon icon-ic-keyboard-arrow-up icon-color"></div>
                    </Button>
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    );
  }

  public render() {
    if (!this.props.event) {
      return;
    }

    return (
      <Card
        className="event"
      >
        <div
          onClick={this.props.event.eventTypeId !== 17 && this.props.event.eventTypeId !== 35 && this.props.event?.eventTypeId !== 38 ? () => this.setState({isDetailsDialogOpen: true}) : undefined}
        >
          <div
            className="event-header"
          >
            <div className="event-avatar">
              {this.props.event.image}
              {!!this.props.event && !!this.props.event.attachments && this.props.event.attachments.length > 0 &&
                <div style={{display: "flex"}}>
                  <div style={{marginLeft: "-3px"}} className="icon icon-ic-note"></div>
                  <span style={{color: "rgba(0, 0, 0, 0.54)", position: "absolute", left: "27px", maxWidth: "19px", overflow: "hidden", whiteSpace: "nowrap"}}>{!!this.props.event && !!this.props.event.attachments && this.props.event.attachments.length}</span>
                </div>
              }
            </div>
            <div className="event-content">
              <div
                className="event-title"
              >
                <div style={{fontSize: "12px"}}>
                  {this.props.event.creatorDisplayName}
                </div>
                <div style={{display: "flex", justifyContent: "flex-end", alignItems: "flex-start"}}>
                  <div style={{fontSize: "12px"}}>
                    {`${this.formatter.formatDate(this.props.event.createdAt)} ${this.formatter.formatTime(this.props.event.createdAt)}`}
                  </div>
                  {this.shouldShowButtons() && this.renderButtons()}
                </div>
              </div>
              {this.renderContent()}
            </div>
          </div>
        </div>

        <PromptDialog
          {...this.props}
          title={this.trans("delete-activity")}
          content={this.trans(`you-are-about-to-delete-${this.props.event.entityTransKey}`, {name: this.props.event.content && this.props.event.content.name})}
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("button-remove")}
          openLeavePrompt={this.state.isDeleteEntityPopupOpen}
          prioritizeClosing={true}
          onDiscard={() => this.setState({ isDeleteEntityPopupOpen: false })}
          onSave={this.delete}
          positiveButtonStyle={{backgroundColor:"red"}}
          hideCross={true}
        />

        {this.renderDetailsDialog()}
      </Card>
    );
  }
}

export { Event };
